import React from "react";
import { Grid } from "@mui/material";
import { FilterRow, FilterWrapper } from "components";
import { TaskStatusFilter } from "modules/shared/filters/TaskStatusFilter";

export const CalcTaskListFilter: React.FC = () => (
  <FilterWrapper>
    <FilterRow>
      <Grid item>
        <TaskStatusFilter />
      </Grid>
    </FilterRow>
  </FilterWrapper>
);
